export enum SupporteeRelation {
    Partner = 'PARTNER',
    Child = 'CHILD',
    Relative = 'RELATIVE',
    HeadOfHousehold = 'HEAD_OF_HOUSEHOLD',
    CoResident = 'CO_RESIDENT',
}
